import React, { Component } from 'react';
import gsap from 'gsap';
import './CustomCursor.css';

class CustomCursor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      isHovering: false
    };
  }

  componentDidMount() {
    this.smallCircle = document.querySelector('.cursor-small-svg');
    this.largeCircle = document.querySelector('.cursor-large-svg');
    this.largeCircleElement = document.querySelector('.cursor-large');
    
    this.posX = 0;
    this.posY = 0;
    this.mouseX = 0;
    this.mouseY = 0;

    // Track mouse position
    document.addEventListener('mousemove', this.handleMouseMove);
    document.documentElement.addEventListener('mouseleave', this.handleMouseLeave);
    document.documentElement.addEventListener('mouseenter', this.handleMouseEnter);
    
    // Start animation loop for smooth following
    gsap.ticker.add(this.updatePosition);
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.documentElement.removeEventListener('mouseleave', this.handleMouseLeave);
    document.documentElement.removeEventListener('mouseenter', this.handleMouseEnter);
    gsap.ticker.remove(this.updatePosition);
  }

  handleMouseLeave = () => {
    this.setState({ isVisible: false });
  }

  handleMouseEnter = () => {
    this.setState({ isVisible: true });
  }

  handleInteractiveEnter = () => {
    this.setState({ isHovering: true });
    if (this.largeCircleElement) {
      gsap.to(this.largeCircleElement, {
        duration: 0.3,
        attr: { r: 30 },
        ease: 'power2.out'
      });
    }
  }

  handleInteractiveLeave = () => {
    this.setState({ isHovering: false });
    if (this.largeCircleElement) {
      gsap.to(this.largeCircleElement, {
        duration: 0.3,
        attr: { r: 12 },
        ease: 'power2.out'
      });
    }
  }

  handleMouseMove = (e) => {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    
    // Show cursor on first mouse movement
    if (!this.state.isVisible) {
      this.setState({ isVisible: true });
    }
    
    // Check if hovering over interactive element
    const target = e.target;
    const isInteractive = target.closest('a, button, input, textarea, select, [role="button"]');
    
    if (isInteractive && !this.state.isHovering) {
      this.handleInteractiveEnter();
    } else if (!isInteractive && this.state.isHovering) {
      this.handleInteractiveLeave();
    }
    
    // Update small circle position immediately
    if (this.smallCircle) {
      gsap.set(this.smallCircle, {
        x: this.mouseX,
        y: this.mouseY
      });
    }
    
    // Animate large circle with eased delay
    if (this.largeCircle) {
      gsap.to(this.largeCircle, {
        duration: 0.3,
        x: this.mouseX,
        y: this.mouseY,
        ease: 'power2.out'
      });
    }
  }

  updatePosition = () => {
    // No longer needed - animation handled in handleMouseMove
  }

  render() {
    const { isVisible } = this.state;
    const containerStyle = {
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.3s ease'
    };

    return (
      <div style={containerStyle}>
        <svg className="custom-cursor cursor-large-svg">
          <circle 
            className="cursor-large" 
            cx="0" 
            cy="0" 
            r="12"
          />
        </svg>
        <svg className="custom-cursor cursor-small-svg">
          <circle 
            className="cursor-small" 
            cx="0" 
            cy="0" 
            r="4"
          />
        </svg>
      </div>
    );
  }
}

export default CustomCursor;
